

















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import Api from '@/project/http/Api.service';
import authService from '@/core/auth/auth.service';
import WebApiMessage from '@/core/messages/WebApiMessage.vue';
import siteService from '@/project/site/site.service';
import serverContextService from '@/core/serverContext.service';
import GTMBasics from '@/project/tracking/gtm/GTM.basics';

@Component({
    components: { WebApiMessage }
})
export default class LoginPanel extends Vue {
    @Prop({ type: String })
    redirect!: string;

    email: string = '';
    password: string = '';
    twoFactorCode: string = '';
    busy = false;
    mode: 'login' | 'twoFactorCode' = 'login';

    forgotPassword() {
        this.$emit('forgot-pw');
    }

    async submit() {
        GTMBasics.pushToDataLayer({
            event: 'button.click',
            buttonTarget: 'login'
        });
        try {
            this.busy = true;
            const response = await Api.authentication.login(
                {
                    email: this.email,
                    password: this.password,
                    siteId: serverContextService.siteInfo.siteId,
                    resendTwoFactorCode: false,
                    twoFactorCode: this.twoFactorCode && this.mode === 'twoFactorCode' ? parseInt(this.twoFactorCode, 10) : undefined
                }, 'login');
            if (response.enableTwoFactorFlow) {
                this.handleTwoFactorMode(response);
            } else {
                // Login success
                this.handlePostLogin(response);
            }
        } catch (err) {
            // Ok, validation-messages will be shown
            // Clear two-factor code in case anything is present
            this.clearTwoFactorCode();
        } finally {
            this.busy = false;
        }
    }

    handlePostLogin(response) {
        authService.logIn(response.token);
        siteService.update(response);
        this.$emit('close');

        if (this.redirect) {
            this.$router.push(this.redirect).catch(e => {});
        }
    }

    handleTwoFactorMode(response) {
        if (response.enableTwoFactorFlow) {
            this.clearTwoFactorCode();
            this.mode = 'twoFactorCode';
        }
    }

    clearTwoFactorCode() {
        this.twoFactorCode = '';
    }

    get registrationPage(): string | undefined {
        return serverContextService.settings?.accessRequestPage;
    }

    close() {
        this.$emit('close');
    }

    backToLogin() {
        this.clearTwoFactorCode();
        this.mode = 'login';
    }
}
